import graphql__544ef87ec2e7a30f1f64 from "./__generated__/CityWalkTimeline_waypoints.graphql.js";import { useState, useCallback, useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { useSwipeable } from "react-swipeable";
import findIndex from "lodash/findIndex";

import CityWalkTimelineWaypoint from "./CityWalkTimelineWaypoint";
import { useMapContext } from "../Maps/MapContext";
import { useFormatMessage } from "../Intl/Context";
import { defineMessages } from "react-intl";
import Button from "../Buttons/Button";

const CityWalkTimeline = props => {
  const waypoints = useFragment(CityWalkTimeline_waypoints, props.waypoints);
  const { mapKey } = useMapContext();

  const currentWaypointIndex = useSelector(({ map }) => {
    const { currentWaypoint } = map[mapKey].cityWalk;
    return currentWaypoint
      ? findIndex(waypoints, waypoint => waypoint.id === currentWaypoint.id)
      : null;
  });

  const t = useFormatMessage();
  const ariaLabel = t(intlMessages.ariaLabel);
  const leftArrowLabel = t(intlMessages.leftArrowLabel);
  const rightArrowLabel = t(intlMessages.rightArrowLabel);

  const waypointWidth = 30 * 2; // width: 30 + margin: 30px
  const containerWidth = waypoints.length * waypointWidth - waypointWidth / 2;
  const currentWaypointOffset = waypointWidth * currentWaypointIndex;

  const [swipeOffset, setSwipeOffset] = useState(0);
  const [offsetX, setOffsetX] = useState(null);

  useEffect(() => {
    if (currentWaypointIndex !== null) {
      setOffsetX(currentWaypointOffset);
    }
  }, [currentWaypointOffset, currentWaypointIndex]);

  const containerOffset = swipeOffset + offsetX;

  const styles = {
    width: `${containerWidth}px`,
    transform: `translateX(${-containerOffset}px)`
  };

  const normalizedSwipeOffset = useCallback(
    offset => {
      const minSwipeOffset = -offsetX;
      const maxSwipeOffset = containerWidth - offsetX;
      return Math.min(Math.max(minSwipeOffset, offset), maxSwipeOffset);
    },
    [offsetX, containerWidth]
  );

  // Swipe handling
  const handlers = useSwipeable({
    onSwiping: ({ deltaX }) => {
      setSwipeOffset(normalizedSwipeOffset(deltaX * 1.5));
    },
    onSwiped: () => {
      setOffsetX(containerOffset);
      setSwipeOffset(0);
    }
  });

  const moveTimelineToNextWaypoint = useCallback(() => {
    setSwipeOffset(normalizedSwipeOffset(swipeOffset - waypointWidth));
  }, [swipeOffset, waypointWidth, normalizedSwipeOffset]);

  const moveTimelineToPreviousWaypoint = useCallback(() => {
    setSwipeOffset(normalizedSwipeOffset(swipeOffset + waypointWidth));
  }, [swipeOffset, waypointWidth, normalizedSwipeOffset]);

  if (currentWaypointIndex === null) return null;

  return (
    <div className="city-walk-timeline box padding-md" {...handlers}>
      <Button
        type="button"
        className="city-walk-timeline-mask-left"
        onClick={moveTimelineToNextWaypoint}
        iconClassName="fa fa-chevron-left"
        screenReaderLabel={leftArrowLabel}
      />
      <Button
        type="button"
        className="city-walk-timeline-mask-right"
        onClick={moveTimelineToPreviousWaypoint}
        iconClassName="fa fa-chevron-right"
        screenReaderLabel={rightArrowLabel}
      />

      <nav className="city-walk-timeline-inner" style={styles} aria-label={ariaLabel}>
        <div className="city-walk-timeline-track" />

        <ul className="city-walk-timeline-waypoints list-unstyled">
          {waypoints.map(waypoint => (
            <CityWalkTimelineWaypoint key={waypoint.id} waypoint={waypoint} />
          ))}
        </ul>
      </nav>
    </div>
  );
};

const CityWalkTimeline_waypoints = graphql__544ef87ec2e7a30f1f64;

export default CityWalkTimeline;

const intlMessages = defineMessages({
  ariaLabel: {
    id: "cityWalk.timeline.ariaLabel",
    defaultMessage: "Étape de la balade"
  },
  leftArrowLabel: {
    id: "cityWalk.timeline.leftArrowLabel",
    defaultMessage: "Faire défiler les étapes vers la gauche"
  },
  rightArrowLabel: {
    id: "cityWalk.timeline.rightArrowLabel",
    defaultMessage: "Faire défiler les étapes vers la droite"
  }
});
